import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { CreateRequestEntry, gatewayRoleLabel } from '@/features/request-gateway';
import { getReturnToFromLocation } from '@/lib/navigationState';
import { routes } from '@/lib/routes';

/**
 * Route-level ENTRY CONTRACT: `/app/requests/new` always mounts the Create Request Hub.
 * Nested legacy paths (`/app/requests/new/*`) and hash layers must not remount a parallel create flow.
 */
const NewRequestPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const activeRole = user?.activeRole || 'SYSTEM_OWNER';

  useEffect(() => {
    // Strip legacy hash create layers (#/app/requests/new/*) without remounting a second flow.
    if (location.hash && /\/?app\/requests\/new/i.test(location.hash)) {
      navigate({ pathname: routes.newRequest, search: location.search, hash: '' }, { replace: true });
    }
  }, [location.hash, location.search, navigate]);

  const leaveHub = () => {
    const returnTo = getReturnToFromLocation(location.state);
    navigate(returnTo || routes.app);
  };

  return (
    <CreateRequestEntry
      isOpen={true}
      onClose={() => navigate(routes.app)}
      onBack={leaveHub}
      activeRole={activeRole}
      roleLabel={gatewayRoleLabel(activeRole)}
    />
  );
};

export default NewRequestPage;
